import service from '@/plugins/service'

const deviceGroupApi = {}

const baseURL = '/station/device/group'

deviceGroupApi.list = (page, size) => {
  return service({
    url: `${baseURL}/list/${page}/${size}`,
    method: 'get'
  })
}

deviceGroupApi.save = (group) => {
  return service({
    url: `${baseURL}/saveGroup`,
    method: 'post',
    data: group
  })
}

deviceGroupApi.get = (code) => {
  return service({
    url: `${baseURL}/get/code/${code}`,
    method: 'get'
  })
}

deviceGroupApi.getById = (id) => {
  return service({
    url: `${baseURL}/get/id/${id}`,
    method: 'get'
  })
}

deviceGroupApi.saveContent = (id, content) => {
  const formData = new FormData()
  formData.append('content', content)
  return service({
    url: `${baseURL}/save/content/${id}`,
    method: 'post',
    data: formData
  })
}

deviceGroupApi.remove = (ids) => {
  const formData = new FormData()
  ids.forEach(id => {
    formData.append('id', id)
  })
  return service({
    url: `${baseURL}/delete`,
    method: 'post',
    data: formData
  })
}

deviceGroupApi.getDeviceState = code => {
  return service({
    url: `${baseURL}/status/${code}`,
    method: 'get'
  })
}

export default deviceGroupApi
